/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$rootScope', '$scope', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'PrincipalProfile', 'FullMemberService', 'calendarEventTitle', 'calendarDateFilter', '$filter'];

    function NavbarController ($rootScope, $scope, $state, Auth, Principal, ProfileService, LoginService, PrincipalProfile, FullMemberService, calendarEventTitle, calendarDateFilter, $filter) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        reloadPrincipalProfile();

        $scope.$on('authenticationSuccess', function(events, args){
            reloadPrincipalProfile();
        });

        $scope.$on('becomeMember', function(events, args){
            reloadPrincipalProfile();
        });

        function reloadPrincipalProfile() {
            if(vm.isAuthenticated()) {
                PrincipalProfile.identity(true).then(function(profile) {
                    vm.profile = profile;
                });
            }
        }

        vm.login = login;
        vm.fullMember = fullMember;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function fullMember() {
            collapseNavbar();
            FullMemberService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        calendarEventTitle.monthView = function(event) {
            if (event.allDay) {
                return event.title;
            }
            var fromDate = new Date(event.startsAt).setHours(0, 0, 0, 0);
            var untilDate = new Date(event.endsAt).setHours(0, 0, 0, 0);
            if (fromDate !== untilDate) {
                if (event.startsAt.getFullYear() === event.endsAt.getFullYear()) {
                    return event.title + ' (' + $filter('date')(event.startsAt, 'dd.MM. HH:mm') + ' - ' + $filter('date')(event.endsAt, 'dd.MM. HH:mm') + ')';
                } else {
                    return event.title + ' (' + $filter('date')(event.startsAt, 'dd.MM.yy HH:mm') + ' - ' + $filter('date')(event.endsAt, 'dd.MM.yy HH:mm') + ')';
                }
            }
            return event.title + ' (' + calendarDateFilter(event.startsAt, 'time', true) + ')';
            // if (event.startsAt === event.endsAt) {
            //     return event.title + ' (' + calendarDateFilter(event.startsAt, 'time', true) + ')';
            // } else {
            //     return event.title + ' (' + calendarDateFilter(event.startsAt, 'time', true) + '-' + calendarDateFilter(event.endsAt, 'time', true) + ')';
            // }
        }

        calendarEventTitle.monthViewTooltip = function(event) {
            if (event.allDay) {
                return event.title;
            }
            var fromDate = new Date(event.startsAt).setHours(0, 0, 0, 0);
            var untilDate = new Date(event.endsAt).setHours(0, 0, 0, 0);
            if (fromDate !== untilDate) {
                if (event.startsAt.getFullYear() === event.endsAt.getFullYear()) {
                    return $filter('date')(event.startsAt, 'dd.MM. HH:mm') + ' - ' + $filter('date')(event.endsAt, 'dd.MM. HH:mm') + ' - ' + event.title;
                } else {
                    return $filter('date')(event.startsAt, 'dd.MM.yy HH:mm') + ' - ' + $filter('date')(event.endsAt, 'dd.MM.yy HH:mm') + ' - ' + event.title;
                }
            }
            return calendarDateFilter(event.startsAt, 'time', true) + ' - ' + event.title;
        }
    }
})();
